import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  updateLotContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 8
  },

  updateLotButton: {
    marginTop: 21,
    width: 112
  },

  updateLotButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.app.colors.text.light,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`
  },

  updateLotInput: {
    width: '100%'
  },

  updateLotButtonContainer: {
    width: '100%',
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',

      '& button': {
        width: '100%'
      }
    }
  },

  updateLotDivider: {
    width: '100% !important'
  }
}))
